<template>
  <div>
    <v-modal-contents ref="modal_contents_agree">

      <template v-slot:close>
        <!--        убираем close-->
        <div></div>
      </template>

      <template v-slot:title>

        <div class="terms_of_use__title ">
          <div class="h2_title">Условия использования персональных данных</div>

        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <div v-html="terms"></div>
          <div class="mt-30">
            <button class="px-30 btn-red "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>

          </div>
        </div>
      </template>
    </v-modal-contents>
    <v-form ref="form" class=" formNew_wrap wow fadeIn form_konteyner_polimernyy_footer" data-wow-delay="0.3s" v-model="valid" lazy-validation>

      <div class="row mx-0 my-0">
        <slot name="description">
          <div class="col-12 col-md-6 col-lg-6 p-md-2">
          </div>
        </slot>
        <div class="col-12 col-md-6 col-lg">
          <div class="row">

            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">

                <v-text-field
                    v-model="name"
                    :rules="[rules.required, rules.ruleTownName]"
                    required=""
                    class="form__input"
                    id="name"
                >

                  <template v-slot:label>
                    ФИО *
                  </template>
                </v-text-field>


              </div>
            </div>
            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">
                <v-text-field
                    v-model="company"
                    :rules="[ rules.ruleOrg]"
                    class="form__input"
                    id="company"

                >
                  <template v-slot:label>
                    Компания
                  </template>
                </v-text-field>
              </div>
            </div>

            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">
                <v-text-field class="form__input"
                              v-model="email"
                              :rules="[rules.mail]"
                              oninput="this.value = this.value.trim()"
                              id="email"
                >
                  <template v-slot:label>
                    Электронная почта
                  </template>
                </v-text-field>

              </div>
            </div>
            <div class="col-12 col-md-6 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item item_tel position-relative">
                <!--            this.value = this.value.replace(/^8/, '');-->
                <!--            oninput="this.value = this.value.replace(/[^\d]/g,''); this.value = this.value.slice(0,10);this.value = this.value.replace(/^\(?8\)?/, '')"-->
                <v-text-field
                    v-model="tel_input"
                    :rules="[rules.required]"
                    required
                    id="tel"
                    oninput="this.value = this.value.replace(/^\(8/, '(');"
                    class="pl-0 form__input"
                    max="20"
                    v-mask="'# ### ###-##-##'"
                >

                  <template v-slot:label>
                    Телефон *
                  </template>
                </v-text-field>


              </div>
            </div>

            <div class="col-12 col-md-12 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item  position-relative form_cooperation__item directionСoop">
<!--                :rules="[rules.required]"-->
                <v-select
                    :items="traySizeItems"
                    item-value="id"
                    label="Размер лотка, мм"
                    v-model="selectTraySize"
                    required=""

                    append-icon="mdi mdi-chevron-down"
                    id="traySizeItems"
                    class="form_cooperation__input "
                    :menu-props="{ contentClass: 'traySizeItems' }"
                    return-object
                >

                  <template v-slot:item="{item}">
                    {{ item.name }}
                  </template>
                  <template v-slot:selection="{item}">
                    {{ item.name }}
                  </template>
                </v-select>
              </div>
            </div>


            <div class="col-12 col-md-12 pb-3 px-3 pt-3">
              <div class="formNew_wrap__item">
                <v-textarea
                    v-model="message"
                    rows="3"
                    class="form__input"
                    id="message"

                >
                  <template v-slot:label>
                    Комментарий
                  </template>
                </v-textarea>
              </div>
            </div>
            <div class="col-12 col-md-12 pb-3 px-3 pt-3">
              <!-- SmartCaptcha -->
              <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                   class="w-100 mt-30"></div>
              <div class="formNew_wrap__item  mt-30">
                <v-checkbox
                    v-model="checkbox"
                    :rules="[(v) => !!v || 'Это обязательный пункт']"
                    required
                    color="red"
                >
                  <template v-slot:label>
                    <div class="customLabelForm">
                      Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                              @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                      использования</a> моих персональных данных для обработки данного обращения
                      ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область,
                      г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю
                      согласие с
                      <a :href="policy" @click="linkOpen(policy)" class="position-relative zi-1">Политикой
                        конфиденциальности</a> и <a :href="agreement"
                                                    @click="linkOpen(agreement)"
                                                    class="position-relative zi-1">Пользовательским
                      соглашением.</a>
                    </div>
                  </template>
                </v-checkbox>

                <v-checkbox
                    v-model="consentToInform"

                    color="red"
                    class="mt-0"
                >
                  <template v-slot:label>
                    <div class="customLabelForm">
                      Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                      предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес:
                      141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,
                      этаж 2) и
                      партнеров.
                    </div>
                  </template>
                </v-checkbox>

                <div class="btn_form d-flex align-items-center  ">
                  <v-btn :disabled="!valid" class=" btn-red w-mc"
                         @click="sendForm">
                    Отправить
                  </v-btn>

                  <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->

                  <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>

    </v-form>
  </div>

</template>
<script>
import VModalContents from "../modal_contents";
import {mask} from 'vue-the-mask';

export default {
  components: {
    VModalContents: VModalContents,
  },
  directives: {mask},
  name: "contactUsFormKPolimernyyFooter",
  props: {
    // lang: Array | String | Number | Boolean | Object,
    // directions: Array | String | Number | Boolean | Object,
    policy: String | Boolean,
    agreement: String | Boolean,
    terms: String | Boolean,
    product: String | Boolean | Number,
    page: String | Boolean,
    iblock: String | Boolean | Number,
  },
  delimiters: ["${", "}"], // Avoid Twig conflicts
  data() {
    return {
      captchaPassed: false,
      valid: true,

      selectTraySize: null,
      traySizeItems: [{"id": 2390, "name": "190х144"}, {"id": 2391, "name": "210х148"}, {"id": 2392, "name": "другой"}],

      rules: {
        required: value => !!value || 'Обязательное поле',
        ruleOrg: value => {
          const patternOn = /[~`@#$%^*={}\[\];:<>.,\/\\-_]/g
          return !patternOn.test(value) || 'Неккоректный ввод'
        },

        ruleProd: value => {
          const patternPd = /[~`@#$%^*={}\[\];:<>.,\/\\-_]/g
          return !patternPd.test(value) || 'Неккоректный ввод'
        },

        ruleTownName: value => {
          const patternSp = /[~`!@№#$%^&*()+={}\[\];:\'\"<>.,]|[0-9_]/g
          return !patternSp.test(value) || 'Неккоректный ввод'
        },

        mail: value => {
          if (!value) return true;
          const pattern = /^(([^<>()[\]\\{\/№%^!#/$?*~+=.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Неккоректная электронная почта'
        },

        phone: value => {
          const pattern = /^\+?[1-9][0-9]{7,14}$/
          return pattern.test(value) || 'Некорректный телефон'
        }
      },
      name: "",
      email: "",
      company: "",
      tel_input: "",
      message: '',
      checkbox: false,
      consentToInform: false,


    };
  },

  methods: {

    linkOpen(url) {
      window.open(url, '_blank');
    },
    // Captcha
    initCaptcha() {
      window.smartCaptcha.render('captcha-container', {
        sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
        callback: this.onCaptchaSuccess,
      });
    },
    onCaptchaSuccess(token) {
      this.captchaPassed = true;
    },
    // Captcha end
    sendForm() {
      if (!this.$refs.form.validate()) return false;
      if (!this.captchaPassed) {
        this.valid = false;
        return false;
      } else {
        this.valid = true;
      }
      /** AJAX */
      var VueObject = this;
      var formData = new FormData();


      let newTel = VueObject.tel_input;
      if (newTel[0] === '7') {
        newTel = "+ " + newTel; // если первая цифра 7, добавляем +
      }
      console.log(newTel);

      formData.append("name", VueObject.name);
      formData.append("phone", newTel);
      formData.append("email", VueObject.email);
      formData.append("selectTraySize", VueObject.getTraySizeValue()); // новое поле
      formData.append("company", VueObject.company);
      formData.append("comment", VueObject.message);
      formData.append("product", VueObject.product);
      formData.append("page", VueObject.page);
      formData.append("iblock", VueObject.iblock);
      formData.append("type", VueObject.getFormTypeTitle() || "footer_solution");
      formData.append("ajaxPost", "Y");
      console.log(formData);
      $.ajax({
        "type": "POST",
        "url": "/ajax/konteyner_form.php", // /ajax/formNew_form.php оригинальный стоял
        "data": formData,
        "cache": false,
        "dataType": 'json',
        "processData": false,
        "contentType": false, // Так jQuery скажет серверу, что это строковой запрос
        "success": function (res) {
          if (VueObject.page == "https://packaging.novaroll.ru/zhestkaya-upakovka/konteyner-polimernyy/") {


            console.log('pageCheck', 'thisPage');
          } else {
            console.log('pageCheck', 'notThisPage');
          }
          
          ym(88483883,'reachGoal','Successful form completion');
          console.log("88483883 reachGoal send success");

          console.log(res);
          $(".text_result").slideDown(300);
          $(".text_result").delay(3000).slideUp(300);
          VueObject.$refs.form.reset();
          setTimeout(function () {
            window.location.reload()
          }, 3000);
        },
        "error": function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.status);
          console.log(thrownError);
        },
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    getFormTypeTitle() {
      var parentForm = this.$el.closest('#formNew');
      var blockTitle = parentForm && parentForm.dataset ? parentForm.dataset.formTypeTitle : "";

      if (blockTitle) return blockTitle;

      var title = this.$el.querySelector('.tapes-order-form__title');

      return title ? title.textContent.replace(/\s+/g, ' ').trim() : "";
    },
    getTraySizeValue() {
      return this.selectTraySize && this.selectTraySize.name ? this.selectTraySize.name : "";
    },

  },
  created() {
    setTimeout(() => {
      this.initCaptcha();
    }, 500)
  },
  watch: {
    captchaPassed() {
      // this.sendForm();
      if (!this.captchaPassed) {
        this.valid = false;
        return false;
      } else {
        this.valid = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../theme/variable";

label[for="traySizeItemRT"],
label[for="traySizeItemRP"],
.form_konteyner_polimernyy_footer {
  & .v-select__slot {
    & i.mdi-chevron-down {
      filter: brightness(0.2);
    }
  }

}
</style>
